import React from 'react';
import { citeOutline } from '../../../lib/models/interfaces';

interface HighlightOverlayProps {
  outlines: citeOutline[];
  pageNumber: number;
  docIndex: number;
  scale: number;
  onOutlineClick?: (outline: citeOutline) => void;
  pageViewports: {
    [docIndex: number]: {
      [pageNumber: number]: { width: number; height: number };
    };
  };
}

export const HighlightOverlay: React.FC<HighlightOverlayProps> = ({
  outlines,
  pageNumber,
  docIndex,
  scale,
  onOutlineClick,
  pageViewports
}) => {
  const viewport = pageViewports[docIndex]?.[pageNumber];
  if (!viewport || outlines.length === 0) {
    return null;
  }

  return (
    <svg
      key={`${docIndex}-${pageNumber}-${scale}`}
      className="absolute inset-0 z-20 h-full w-full"
      style={{ pointerEvents: onOutlineClick ? 'auto' : 'none' }}
    >
      {outlines.map((outline, idx) => {
        if (
          outline.pageNumber !== pageNumber ||
          outline.docIndex !== docIndex
        ) {
          return null;
        }

        const x = outline.x * viewport.width;
        const y = outline.y * viewport.height;
        const width = outline.width * viewport.width;
        const height = outline.height * viewport.height;

        return (
          <rect
            key={`${outline.pageNumber}-${idx}`}
            x={x}
            y={y}
            width={width}
            height={height}
            fill="yellow"
            fillOpacity="0.3"
            pointerEvents={
              onOutlineClick && outline.sentenceIds?.length ? 'all' : 'none'
            }
            style={{
              cursor:
                onOutlineClick && outline.sentenceIds?.length
                  ? 'pointer'
                  : 'default'
            }}
            onClick={(event) => {
              event.stopPropagation();
              onOutlineClick?.(outline);
            }}
          />
        );
      })}
    </svg>
  );
};
